import { Link } from 'react-router-dom';
import { Button, Icon, useAction } from '@onepos/ui';
import { APP_URL, api } from '../lib/api';
import { useAuth } from '../lib/auth';
import { fmtDateTime } from '../lib/format';
import type { PlatformMe } from '../lib/types';

export function SupportBanner({ support }: { support: NonNullable<PlatformMe['support']> }) {
  const { refreshMe } = useAuth();
  const end = useAction(async () => {
    await api.rpc('platform_support_end');
    await refreshMe();
  });
  return (
    <div className="cn-support" role="status">
      <Icon name="shield" />
      <span style={{ flex: 1, minWidth: 200 }}>
        <strong>Yordam rejimi</strong> — {support.tenant_name} ({support.mode === 'write' ? 'sozlash' : 'faqat ko‘rish'}),
        {' '}tugaydi {fmtDateTime(support.expires_at)}
        {end.error && <span className="cn-support__err"> · {end.error}</span>}
      </span>
      <Link className="op-btn op-btn--sm op-btn--secondary" to={`/restoranlar/${support.tenant_id}`}>
        Restoran
      </Link>
      <a className="op-btn op-btn--sm op-btn--secondary" href={`${APP_URL}/yordam`} target="_blank" rel="noopener noreferrer">
        Panelni ochish
      </a>
      <Button size="sm" variant="primary" disabled={end.busy} onClick={() => void end.run()}>
        Yakunlash
      </Button>
    </div>
  );
}
